import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const LockIcon = (props) => (
  <SvgIcon {...props}>
    <path d="M12 17a2 2 0 0 0 2-2a2 2 0 0 0-2-2a2 2 0 0 0-2 2a2 2 0 0 0 2 2m6-9a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2h1V6a5 5 0 0 1 5-5a5 5 0 0 1 5 5v2h1m-6-5a3 3 0 0 0-3 3v2h6V6a3 3 0 0 0-3-3z" />
  </SvgIcon>
);
LockIcon.displayName = 'LockIcon';
LockIcon.muiName = 'SvgIcon';

export default LockIcon;
